import _isPlaceholder from './_isPlaceholder';

/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
export default function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_curry1.js
// module id = j+Mk
// module chunks = 22